import React, { useState, useEffect } from 'react';
import { Tree } from '../../../types/tree';
import { InfoRow } from '../../../components/InfoRow';
import { useBlocks, useCultures, useVarieties } from '../../../helpers/hooks';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMap, faSeedling, faAppleAlt, faLocationDot, faListOl } from "@fortawesome/free-solid-svg-icons";

interface TreeCardProps {
  tree: Tree | undefined;
  showName?: boolean;
}

export const TreeCard: React.FC<TreeCardProps> = ({ 
  tree,
  showName = true
}) => {
    
   const {toBlockName} = useBlocks();
   const {toCultureName} = useCultures();
   const {toVarietyName} = useVarieties(tree?.cultureID || '');

   const blockName = toBlockName(tree?.blockID) || '';
   const cultureName = toCultureName(tree?.cultureID);
   const varietyName = toVarietyName(tree?.varietyID);


  if (!tree) {
    return <div>Tree not found</div>;
  }

  return (
    <div className="card mb-3" style={{ maxWidth: '500px' }}>
      <div className="card-body">

        {showName && 
        <h6 
          className="card-title mb-3" 
          style={{fontSize: '1.25rem', 
                  fontWeight: 'bold', 
                  color: 'var(--bs-primary)',
                  textAlign: 'center' }}>
          {tree.description}
        </h6>}
        
        <div className="row">
          <div className="col-md-6">
            <InfoRow 
              icon={() => <FontAwesomeIcon icon={faMap} />} 
              label="Secteur" 
              value={blockName}
            />
            <InfoRow 
              icon={() => <FontAwesomeIcon icon={faSeedling} />} 
              label="Culture / Variété" 
              value= {`${cultureName} / ${varietyName}`}
            />
          </div>
          
          <div className="col-md-6">
            {tree.position_x && tree.position_y &&
              <InfoRow 
                icon={() => <FontAwesomeIcon icon={faLocationDot} />}
                label="Coordonnées" 
                  value={`(${tree.position_x}, ${tree.position_y})`} 
                />
            }

            {tree.row_number && tree.index_in_row &&
              <InfoRow 
                icon={() => <FontAwesomeIcon icon={faListOl} />}
                label="Ligne et position" 
                value={`Ligne: ${tree.row_number}, Position: ${tree.index_in_row}`} 
              />
            }
          </div>
        </div>
      </div>
    </div>
  );
};
